import { useState } from 'react';
import axios from 'axios';

const useProductNotification = () => {
  const ProductNotification = async (email,productId) => {
    const payload = { email,productId };
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}collection/product-notifications/`, {
        "product":productId,
        "email":email
    });
      return response.success;
    } catch (error) {
      console.error('Error submitting email:', error);
      throw error;
    }
  };

  return { ProductNotification };
};

export default useProductNotification;